import { Component } from "../Component";
import { Subject, combineLatest as observableCombineLatest, timer } from "rxjs";
import { AxisscaleBar } from "./AxisscaleBar";
import { AxisscaleBarDOMRenderer } from "./AxisscaleBarDOMRenderer";
import { debounce, distinctUntilChanged, first, map } from "rxjs/operators";
export class AxisscaleBarComponent extends Component {
    constructor(name, container, navigator, dom) {
        super(name, container, navigator);
        this._axisscalebarDOMRenderer = new AxisscaleBarDOMRenderer(container);
        this._containerWidth$ = new Subject();
        this._axisscalebar = new AxisscaleBar(this._container, this._navigator);
    }
    get axisscalebar() {
        return this._axisscalebar;
    }
    _activate() {
        this._renderSubscription = observableCombineLatest([this._configuration$, this._containerWidth$])
            .pipe(map(([configuration, containerWidth]) => {
            const vNode = this._axisscalebarDOMRenderer.render(configuration, containerWidth, this, this._navigator);
            return { name: this._name, vnode: vNode };
        }))
            .subscribe(this._container.domRenderer.render$);
        this._containerWidthSubscription = observableCombineLatest([
            this._container.renderService.size$,
            this._configuration$.pipe(distinctUntilChanged((value1, value2) => {
                return value1[0] === value2[0] && value1[1] === value2[1];
            }, (configuration) => {
                return [configuration.minWidth, configuration.maxWidth];
            })),
        ])
            .pipe(map(([size, configuration]) => {
            return this._axisscalebarDOMRenderer.getContainerWidth(size, configuration);
        }))
            .subscribe(this._containerWidth$);
        observableCombineLatest([this._configuration$, this._container.domRenderer.element$.pipe(first())])
            .pipe(map(([configuration, element]) => {
            const elements = (element.getElementsByClassName("infra3dsdk-axisscalebar-container"));
            if (elements.length > 0) {
                this._axisscalebar.deactivate();
                this._axisscalebar.activate(elements[0], configuration);
                this.resize();
            }
        }))
            .subscribe();
        this._setTimelinetoggleSubscription = this._axisscalebar.axisscaleBarLoaded$
            .pipe(debounce((x) => {
            if (!x)
                return timer(3000);
            return timer(0);
        }), distinctUntilChanged())
            .subscribe((axisloaded) => {
            this._navigator.playService.setTimelinetoggle(axisloaded);
        });
        this._timelinetoggleSubscription = this._navigator.playService.timelinetoggle$.subscribe((toggle) => {
            this.configure({
                visible: toggle,
            });
        });
        this._resizeSubscription = this._containerWidth$.subscribe((width) => {
            this.resize();
        });
    }
    _deactivate() {
        this._renderSubscription.unsubscribe();
        this._containerWidthSubscription.unsubscribe();
        this._setTimelinetoggleSubscription.unsubscribe();
        this._timelinetoggleSubscription.unsubscribe();
        this._resizeSubscription.unsubscribe();
        this._axisscalebar.deactivate();
        delete this._axisscalebar;
        this._axisscalebar = null;
    }
    _getDefaultConfiguration() {
        return {
            minWidth: 200,
            maxWidth: 1000,
            km_stroke_dist: 100,
            km_stroke: true,
            labelaccuracy: 1,
            labelattribute: null,
            centerOffsetY: 18,
            labelOffset: 3,
            font: "normal 12pt Calibri",
            axiscolor: "#272727",
            axispoint_radius: 4,
            visible: true,
            showdirectionmode: "viewingdirection_binary",
            width: 1000,
            stroke_label: 5,
        };
    }
    resize() {
        this._axisscalebar.resize();
    }
    configure(newConf) {
        //Todo: check configurations
        /* const conf = this._getDefaultConfiguration();
        for (const key in newConf) {
            if (Object.prototype.hasOwnProperty.call(newConf, key)) {
                conf[key] = <any>newConf[key];
            }
        } */
        this._configurationSubject$.next(newConf);
    }
}
AxisscaleBarComponent.componentName = "axisscalebar";
//# sourceMappingURL=AxisscaleBarComponent.js.map